<template>
  <div class="container" style="margin:120px auto">
    <div class="row">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3">{{ $t('Home.Daily_English') }}
            <span v-for="item in dailySentencesList">
              <button type="button" :class="{'active': item.id.includes(dailySentencesType) }" @click="selectType(item.id)" class="btn btn-sm btn-outline-danger ml-1">{{ item.name }}</button>
            </span>
          </h3>
          <div class="line"></div>
        </div>
        <keep-alive>
          <DailySentence :inputAudioData="audioData"/>
        </keep-alive>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex my-3">
          <h3 class="title d-flex  align-items-center"><img style="height:26px" src="../assets/image/CNN logo.jpg" alt="" srcset="">{{ $t('Home.World_News') }}
            <span class="hint ml-2 mr-3">每週一、三、五更新</span>
          </h3>
          <div class="line" style="width:95%"></div>
        </div>
        <div>
          <keep-alive v-if="dailyNewsItem && dailyNewsViewId">
            <DailyNews class="pr-3 my-4" :inputNews="dailyNewsItem" :view_id="dailyNewsViewId"/>
          </keep-alive>
          <div v-else>
            <h4>
              請先完成學前測驗
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">最新話題字</h3>
          <div class="line" style="width:95%"></div>
        </div>
        <div>
          <div v-if="hotWord">
            <div class="d-flex justify-content-between">
              <span class="rwd-hide hint">每週一更新</span>
              <span class="pointer" @click="goModalList('278')">
                <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
                <span class="rwd-hide">
                  {{ $t('Home.watch_more') }}
                </span>
              </span>
            </div>
            <div @click="goPage(hotWord.id)">
              <div class="picture image-box pointer" style="min-height: 200px; max-height: 200px;" :data-level="hotWord.cefr" >
                <img class="cover" :src="hotWord.cover" alt="">
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{hotWord.name}}
                </p>
                <p class="m-0" style="font-size:.8rem">
                  {{hotWord.name_en}}
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <h4>
              請先完成學前測驗
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">{{ $t('Home.Lets_play_in_English') }}</h3>
          <div class="line"></div>
        </div>
        <div v-if="dailyEnglish">
          <div class="d-flex justify-content-between">
            <span class="rwd-hide hint">每週四更新</span>
            <span class="pointer" @click="goModalList('282')">
              <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
              <span class="rwd-hide">
                {{ $t('Home.watch_more') }}
              </span>
            </span>
          </div>
          <div @click="goPage(dailyEnglish.id)">
            <div class="picture image-box pointer" style="min-height: 200px; max-height: 200px;" :data-level="dailyEnglish.cefr" >
              <img class="cover" :src="dailyEnglish.cover" alt="">
            </div>
            <div class="ml-2">
              <p class="m-0" style="font-size:1.1rem">
                {{dailyEnglish.name}}
              </p>
              <p class="m-0" style="font-size:.8rem">
                {{dailyEnglish.name_en}}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <h4>
            請先完成學前測驗
          </h4>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">老外帶你遊臺灣</h3>
          <div class="line"></div>
        </div>
        <div v-if="travelTaiwan">
          <div class="d-flex justify-content-between">
            <span class="rwd-hide hint">每週二更新</span>
            <span class="pointer" @click="goModalList('280')">
              <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
              <span class="rwd-hide">
                {{ $t('Home.watch_more') }}
              </span>
            </span>
          </div>
          <div @click="goPage(travelTaiwan.id)">
            <div class="picture image-box pointer" style="min-height: 200px; max-height: 200px;" :data-level="travelTaiwan.cefr" >
              <img class="cover" :src="travelTaiwan.cover" alt="">
            </div>
            <div class="ml-2">
              <p class="m-0" style="font-size:1.1rem">
                {{travelTaiwan.name}}
              </p>
              <p class="m-0" style="font-size:.8rem">
                {{travelTaiwan.name_en}}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <h4>
            請先完成學前測驗
          </h4>
        </div>
      </div>
    </div>
    <div class="row" v-if="recordLesson.length>0">
      <div class="col-md-12">
        <div class="d-flex my-3">
          <h3 class="title pr-3">
            {{ $t('Home.Learning_History') }}
          </h3>
          <div class="line"></div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3 col-md-6 col-12" v-for="(item, index) in recordLesson.slice(0,4)" :key="index">
            <div @click="goPage(item.id)">
              <div class="picture image-box pointer" :data-level="item.cefr" >
                <img class="cover" :src="item.cover" alt="">
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{item.name}}
                </p>
                <p class="m-0" style="font-size:.8rem">
                  {{item.name_en}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="recentLessons.length>0">
      <div class="col">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">{{ $t('Home.Latest_Courses') }}
          </h3>
          <div class="line"></div>
        </div>
        <div style="text-align:right;width:100%">
          <span class="text-danger pointer" @click="goList()">
            More
          </span>
        </div>
        <div class="row my-3">
          <div class="col-lg-3 col-md-6 col-12" v-for="(item, index) in recentLessons.slice(0,4)" :key="index">
            <div @click="goPage(item.id)">
              <div class="picture image-box pointer" :data-level="item.cefr" >
                <img class="cover" :src="item.cover" alt="">
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{item.name}}
                </p>
                <p class="m-0" style="font-size:.8rem">
                  {{item.name_en}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3">{{ $t('Home.Recommend') }}
          </h3>
          <div class="line"></div>
        </div>
          <div class="row my-3">
            <div class="col-lg-6 col-12" v-for="(item, index) in recommendLesson.slice(0,4)" :key="index">
            <div class="d-sm-flex my-2">
              <div style="text-align:center;" @click="goCourse(item.id)">
                <img class="m-auto pointer" style="max-width:265px" :src="item.cover" alt="">
              </div>
              <div style="border:solid 1px #ccc;" class="p-2 m-4 m-sm-0">
                <h4 class="m-0">
                  {{item.name}}
                </h4>
                <p class="m-0" style="font-size:1rem">
                  {{item.name_en}}
                </p>
                <span v-for="(el, index) in item.cefr.split(',')" :key="index" class="badge badge-danger mx-1 p-1">{{el}}</span>
                <div class="mt-3" style="height:75%; overflow: auto;">
                  <p style="height:150px">
                    {{item.description}}
                  </p>
                  <div class="p-2" style="text-align:right;">
                    <button type="button" @click="goCourse(item.id)" class="btn btn-dark">{{ $t('Home.Go_to_course') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3">{{ $t('Home.Learning_Guides') }}</h3>
          <div class="line"></div>
        </div>
        <div class="row my-3 align-items-stretch" style="postition: relative">
          <div class="col-md-3">
            <div style="border:solid 1px #ccc;height:100%">
              <div style="background:red;text-align:center">
                <h4 class="p-2" style="color:#fff">CEFR定義</h4>
              </div>
              <div class="p-2">
                <div>
                  <p style="font-size: .9rem">
                    CEFR為歐洲語言共同參考標準（Common European Framework of Reference for Languages: Learning, Teaching, Assessment，常簡稱CEFR）是歐洲委員會在2001年11月通過的一套建議標準，為歐洲語言在評量學習、教學、評量架構和教學指引、考試、教材所提供的基準，可用來評估語言學習者在所學語言的成就，並將語言程度所應具備的能力分成A1到C2六個等級，含聽、說、讀、寫、連續的表達和參與對話五項技能分級界定。CEFR受到多國政府、企業與學術機構認可，許多國際性英檢，如多益、托福、雅思皆已採用。
                  </p>
                </div>
              </div>
              <div style="text-align: right">
                <button type="button" @click="goExam()" class="btn btn-danger mx-2 mb-2">了解目前能力</button>
              </div>
            </div>
            <!-- <div style="text-align: left">
              <button type="button" class="btn btn-danger my-2">了解目前能力</button>
            </div> -->
          </div>
          <div class="col-md-9">
            <div class="cefr-pic">
              <img style="width:100%;" src="../assets/image/LLPRO_CEFR_banner_bg.png" alt="">
              <img style="width:15%; position:absolute; bottom:16%; left:5%" src="../assets/image/LLPRO_CEFR_banner_woman.png" alt="">
              <img style="width:20%; position:absolute; bottom:50%; right:0" src="../assets/image/LLPRO_CEFR_banner_man.png" alt="">
              <div class="m-3 p-2 cefr-content" v-for="(item, index) in chats" :key="index">
                <div v-if="index === currentBar">
                  <div class="d-flex">
                    <div class="cefr-title mr-2 mb-3">
                      <span class="cefr-icon"> {{item.level}}</span>
                      <span class="mx-2">
                        <span>{{item.name}} {{item.subName}}</span>
                        |
                        <span class="cefr-range" v-if="item.range">{{item.range}}​</span>
                      </span>
                    </div>
                  </div>
                  <div class="mb-3">
                    <button :class="{'active':isAdvice === true}" @click="infoToggle(true)" type="button" class="btn btn-sm btn-outline-secondary mr-2">能力說明</button>
                    <button :class="{'active':isAdvice === false}" @click="infoToggle(false)" type="button" class="btn btn-sm btn-outline-secondary">學習建議</button>
                  </div>
                  <div v-if="isAdvice">
                    <div v-for="(item, index) in item.text" :key="index">
                      <p>{{index+1}}. {{item}}​</p>
                    </div>
                  </div>
                  <div v-else>
                    {{item.advice}}
                  </div>
                  </div>
                </div>
              <div class="d-flex chart">
                <div class="bar-layout" v-for="(item, index) in chats" :key="index">
                  <div class="mx-auto bar pointer d-flex justify-content-center align-items-end" @click="currentBar = index" :style="{height: item.bar}" :class="{'active': currentBar === index}">
                    <div class="bar-text">
                      {{item.level}}
                    </div>
                  </div>
                  <div class="bar-name">{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Player from 'live-player/dist/Player'
import DailyNews from '@/components/DailyNews.vue'
import DailySentence from '@/components/DailySentence.vue'
import DailyModal from '@/components/DailyModal.vue'
import apiLibrary from '../store/library/api'
import api from '../store/api'

export default {
  name: 'Home',
  components: {
    Player,
    DailyNews,
    DailySentence,
    DailyModal
  },
  computed: {
    ...mapGetters([
      'authInfo'
    ]),
    dailyNewsItem () {
      return Array.isArray(this.dailyNews) && this.dailyNews.length ? this.dailyNews[0] : null
    },
    dailyNewsViewId () {
      const firstSection = this.dailyNewsItem && this.dailyNewsItem.sections && this.dailyNewsItem.sections[0]
      return firstSection && firstSection.data ? firstSection.data.view_id : null
    }
  },
  watch: {
    dailySentencesType (val) {
      if (val) {
        this.getDailySentences()
      }
    }
  },
  data () {
    return {
      audioData: null,
      recentLessons: [],
      recommendLesson: [],
      recordLesson: [],
      dailyNews: null,
      dailyEnglish: null,
      dailySentencesList: [],
      dailySentencesType: [],
      channels: [],
      travelTaiwan: null,
      hotWord: null,
      exam: null,
      isAdvice: true,
      chats: [
        {
          name: '基礎級',
          subName: 'Breakthrough',
          level: 'A1',
          range: 'TOEIC: < 225',
          bar: '8%',
          text:[
            '運用所學的字母拼讀規則拼寫、讀出英文字詞與簡單語句。​',
            '以正確的發音及適切語速朗讀簡易對話、歌謠韻文、故事短劇。​',
            '聽懂日常生活應對中的常用語句，如:自我介紹、居住地、人際關係，​ 並能作簡短的回應。'
          ],
          advice: '此階段學員建議從KK音標、發音規則開始學起，熟悉英文的音節、重音及語調，跟著教材開口說英文。接著背誦基礎英語1200字，累積生活英語的字彙量。有了一定的字彙量後，即可學習簡易的句子，例如「學習資源」中的「社交必備句」或「生活對話好用句」。藉由使用「句子跟讀」功能，複誦、並記下教材中的句子，累積學員基礎對話實力。'
        },
        {
          name: '初級',
          subName: 'Waystage',
          level: 'A2',
          range: 'TOEIC: 225-550​',
          bar: '16%',
          text:[
            '聽懂日常生活對話、簡易故事、簡易廣播，並能以簡單的字詞、句子記下要點。​​',
            '看懂日常溝通中簡易的書信、 簡訊、 留言、賀卡、邀請卡等，並能以口語或書面作簡短的回應。​​',
            '掌握重要的閱讀技巧如擷取大意、猜測字義、推敲文意、預測後續文意及情節發展……等。​'
          ],
          advice: '此階段學員已具備基本的字彙量，建議藉由互動教材中「單字」、「字典」查找的功能，更多學習生字、擴增字彙量；並使用「收藏」功能，建立專屬自己的單字本。針對想增進閱讀能力的學員，建議從「生活英語」中的「健康好食尚」「經典文學館」「名人超新星」三門課學起。聽力與口說的部份則可瀏覽「節慶文化」、「週末放輕鬆」、「生活實用情境」三門課，跟著課程影片聆聽與跟讀，培養實用語境下的各種英語表達能力。'
        },
        {
          name: '中級',
          subName: 'Threshold',
          level: 'B1',
          range: 'TOEIC: 550-785​',
          bar: '24%',
          text:[
            '以正確的發音及適切的斷句、節奏、語調、語氣及速度，流暢地朗讀短文、短劇及故事，並能以自己的話轉述談話或故事。​',
            '在工作時，能閱讀工作須知、公告、操作手冊、例行的文件、傳真、電報等。​​',
            '能了解及閱讀比較不同體裁、不同主題之文章，並據以發表心得、進行評析。​'
          ],
          advice: '此階段學員已具備一定的閱讀能力與字彙量。也能在工作時，閱讀例行的英文文件。建議從「生活英語」中的「健康好食尚」「名人超新星」、「節慶文化」、「週末放輕鬆」、「生活實用情境」幾門課的B1進階課程，大聲朗讀課文、跟讀對話，增進英語的語感與中級表達能力。商業英語部份，可從「學習資源」中的「商英必備句」累積職場必備語彙庫，並從「商業英語」中的「商業接待」、「電話客服」課程，學習如何用英語接待客戶、與客戶電話溝通。寫的部份，可使用「寫作教室」中的基礎商業寫作課程，進行文章寫作練習。'
        },
        {
          name: '中高級',
          subName: 'Upper Intermediate',
          level: 'B2',
          range: 'TOEIC: 785-945​',
          bar: '32%',
          text:[
            '能夠理解具體或抽象的話題，包括與自身專業領域相關的技術性研討。​',
            '日常生活中聽得懂演講、報導與節目；工作時，能聽懂簡報、討論、產品介紹及操作說明。 ',
            '能夠接待外籍人士、介紹工作內容、洽談業務、在會議中發言，以及撰寫工作報告和書信。​'
          ],
          advice: '此階段學員已能理解不同主題、具體或抽象的話題，也對可用英語進行簡報、產品介紹與自身專業領域相關用字。建議學員從「商業英語」中的「商務會議」開始，掌握會前籌備、主持會議英語、視訊會議必備英語語彙。後續可持續以「經營管理」、「業務行銷」、「商展旅行」等課程，增進商業英語溝通能力。新聞英語的部份，可透過收藏功能儲存首頁「每日一句」，建立專屬自己的新聞語彙資料庫。'
        },
        {
          name: '高級',
          subName: 'Advanced',
          level: 'C1',
          range: 'TOEIC: > 945',
          bar: '40%',
          text:[
            '能聽懂各類各類主題的談話、辯論、演講、報導及節目等。​',
            '能閱讀各類不同主題、體裁的文章，包括報章雜誌、文學作品、專業期刊、學術著作及文獻等。​',
            '對各類主題均能流暢地表達看法、參與討論，能在一般會議或專業研討會中報告或發表意見等，並能撰寫專業性報告、論文、新聞報導。​'
          ],
          advice: '此階段的學員除自身領域外，也能瞭解跨領域、多重領域的英文內容，並能閱讀長篇文章，用英語談論不同領域的知識。故建議此階段學員從「新聞英語」主題中的「Focus全球新聞」和「新冠疫情專欄」兩門課，掌握最新時事，並試著單看影片，僅憑自身的英聽能力來理解通篇新聞的內容。若聽完後，發現有不解之處，再打開「文字」功能，重新播放，確認聽不清楚的部份，並收藏單字。寫作部份，若需要進行練習，可從「商業寫作」進階課程開始寫起。也可參與「直播教室」進行主題式增能課程。 '
        },
        {
          name: '精熟級',
          subName: 'Proficiency',
          level: 'C2',
          range: '',
          bar: '48%',
          text:[
            '能聽懂、讀懂各類主題及體裁的內容，理解程度與受過高等教育之母語人士相當。​',
            '能在各種不同場合以正確流利之英語表達看法；能適切引用文化知識、慣用語詞與專有名詞。​',
            '能撰寫不同性質的文章，如企劃報告、專業/學術性摘要、論文、新聞報導及時事評論等。對於各類主題均能有效完整地闡述並作深入探討。'
          ],
          advice: '此階段學員已具備菁英級母語人士能力，相當於英語學術界專業人士的程度。建議此階段的學員持續以「新聞英語」中的「科技創新」、「商業財經」、「深度旅遊」等主題，單看影片不開「文字」功能，維持英文聽力與字彙。也可參與「直播教室」進行主題式增能課程。'
        }
      ],
      currentBar: 0
    }
  },
  mounted () {
    if (this.authInfo.user.aiOnly) {
      this.$router.push({ name: 'ai_assistantIntro' })
    }
    this.getNewsData()
    this.scrollTop()
    this.getExam()
    this.getDailySentencesList()
    this.getDailySentences()
    if (this.authInfo.user.forcePreTest) {
      if (this.authInfo.user.isFinishPreTest) {
        this.getNews()
        this.getEnglish()
        this.getHotWord()
        this.getTravelTaiwan()
      }
    } else {
      this.getNews()
      this.getEnglish()
      this.getHotWord()
      this.getTravelTaiwan()
    }
    this.getRecentLessons()
    this.getRecordLessons()
    this.getRecommendLessons()
  },
  methods: {
    async getDailySentencesList () {
      const { data } = await apiLibrary.get('/v1/daily-sentences/categories/livelearningpro')
      this.dailySentencesList = data
      // 預設type為第一顆按鈕
      this.dailySentencesType = data[0].id
    },
    async getDailySentences () {
      const { data } = await apiLibrary.get(`/v1/daily-sentences?category=${this.dailySentencesType}`)
      this.checkCollections([data.data[0]])
    },
    selectType (id) {
      this.dailySentencesType = id
    },
    async getNews() {
      const params = {
        page: 1,
        pageSize: 1,
        orderBy: 'desc',
        categories: 2,
        // type: 'daily_news'
      }
      const { data } = await api.get('/contents/courses/', { params })
      this.dailyNews = data.data
    },
    async getEnglish() {
      const params = {
        page: 1,
        pageSize: 1,
        sort: 'public_at',
        order: 'desc'
      }
      const { data } = await api.get('/contents/package_courses/282/courses', { params })
      this.dailyEnglish = data.data[0]
    },
    async getHotWord() {
      const params = {
        page: 1,
        pageSize: 1,
        sort: 'public_at',
        order: 'desc'
      }
      const { data } = await api.get('/contents/package_courses/278/courses', { params })
      this.hotWord = data.data[0]
    },
    async getTravelTaiwan() {
      const params = {
        page: 1,
        pageSize: 1,
        sort: 'public_at',
        order: 'desc'
      }
      const { data } = await api.get('/contents/package_courses/280/courses', { params })
      this.travelTaiwan = data.data[0]
    },
    async getRecentLessons() {
      const { data } = await api.get('contents/courses/recent')
      this.recentLessons = data.data
    },
    async getRecordLessons() {
      const params = {
        page:1,
        pageSize:4
      }
      const { data } = await api.get('/contents/courses/history', params)
      this.recordLesson = data.data
    },
    async getRecommendLessons() {
      const { data } = await api.get('contents/courses/recommend')
      // let item = data.data[Math.floor(Math.random()*data.data.length)]
      this.recommendLesson = data.data
    },
    async checkCollections (el) {
      let str = ''
      let checkArray = []
      for (const item in el) {
        str += el[item].id + ','
      }
      try {
        const { data } = await api.get(`collections/daily_sentence/check?ids=${str}`)
        checkArray = data.data
      } catch (error) {
        console.error(error.response.data)
      }
      for (const item in el) {
        const idx = checkArray.indexOf((el[item].id))
        if (idx > -1) {
          el[item].collection = true
        } else {
          el[item].collection = false
        }
      }
      this.audioData = el
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        this.$nextTick(() => {
          // this.getParents(data.data.category_id)
        })
        return data.data
      }
    },
    async getExam () {
      const { data } = await api.get('/contents/exams?page=1&pageSize=10&type=classify')
      this.exam = data.data[0]
    },
    goExam() {
      this.$router.push({ name: 'Exam-area' })
    },
    async goPage (id) {
        await this.getLessonId(id).then((val) => {
        this.$router.push({ name: 'CourseLesson', params: { lesson: val.id, courseId: val.sections[0].data.view_id||val.sections[0].id } })
      } )
    },
    async goList ()  {
      this.$router.push({ name: 'Search' })
    },
    async goCourse (id) {
      this.$router.push({ name: 'Course', params: { channel: id } })
    },
    async goModalList (id) {
      this.$router.push({ name: 'modalList', params: { courseId: id } })
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        return data.data
      }
    },
    infoToggle (el) {
      this.isAdvice = el
    },
    scrollTop () {
    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    },
    async getNewsData () {
      // const { data } = await libraryApi.get(`/v1/livelibrary/Lesson/${this.view_id}`)
      const { data } = await api.get(`/contents/lesson/D9C089BD-9C01-4E43-A0E3-D7C2D571AA2B`)
      if (data.status === 'OK') {
        data.data.modules[0].vocabularies = []
        data.data.modules[0].highlights = []
        this.newsData = data.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../assets/styles/color.scss";

  .container {
    text-align: left;
  }
  .title {
    font-size: 1.5rem;
    font-weight: bolder;
    color: $main-color;
    background-color: $white-color;
    z-index: 10;
  }
  .line {
    // width: 100%;
    width: 98%;
    position: absolute;
    // left: 100%;
    top: 32px;
    border-top: black 1px solid;
  }
  .hint {
    font-weight: 800;
    font-size: 1rem;
    color: rgb(182, 180, 180);
  }
  .picture .cover:hover {
    transform: scale(1.05)  translate(-50%,-50%);
    filter:opacity(.8);
  }
  .picture {
    position:relative;
    min-height: 150px;
    max-height: 150px;
    overflow: hidden;
    .cover {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition:all 0.2s ease;
    }
    .tag {
      width: 40px;
      position: absolute;
      padding: 10px
    }
  }
  .image-box::after {
    content: attr(data-level);
    padding: 5px;
    width: 30px;
    height: 30px;
    border-radius: 20%;
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: $main-color;
    color:white;
  }
  //.image-box::before {
  //  content: attr(data-time);
  //  padding: 1px;
  //  z-index: 2;
  //  position: absolute;
  //  bottom: 10px;
  //  right: 10px;
  //  font-size: .5rem;
  //  background-color: rgba(0, 0, 0, 0.6);
  //  color: white;
  //}
  .cefr-pic {
    position: relative;
    .cefr-content {
      .cefr-title {
        font-size: 1.2rem;
        font-weight: bold;
        color: $main-color;
        .cefr-icon {
          color: #fff;
          background-color: red;
          padding: 2px 8px;
          border-radius: 4px;

        }
      }
      .bg-danger {
        color: #fff;
      }
      border-radius: 20px;
      width: 70%;
      position: absolute;
      top: 0;
      z-index:50 !important;
    }
    .btn:hover,
    .btn:focus {
      outline: none;
      box-shadow: none !important;
    }
    .bar-layout {
      width: 100%;
      position: relative;
      .bar-name {
        font-weight: bold;
        position: absolute;
        bottom:10px;
        text-align:center;
        width:100%;
      }
      .bar {
        border-radius: 10px 10px 0 0;
        width:50%;
        background:rgb(255, 185, 185);
        position: absolute;
        bottom: 40px;
        right: 25%;
        transition: all .5s cubic-bezier(0.42, 0, 0.58, 1.0);
        .bar-text {
          color:#fff;
        }
      }
      .active {
        background: red;
      }
    }
  }
  .subtitle {
    margin: 2%;
    width: 96%;
    line-height: 3rem;
    font-size: 1.5rem;
    box-shadow: 4px 2px 2px 2px rgba(0, 0, 0, 0.2);
  }
  .pop-title {
    h4 {
      margin: 0;
      font-size: 1rem !important;
    }
  }
  .chart {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
  }
  @media(max-width: 1280px){
    .cefr-pic {
      margin-top: 20px;
      width: 100%;
      height: 550px;
      border-radius: 10px;
      background: url('../assets/image/LLPRO_CEFR_banner_bg.png');
      background-size: cover;
      background-position: center;
      img {
        display: none;
      }
    }
    .cefr-content {
      p {
        padding: 0 20px 0 0;
      }
      width: 100% !important;
    }
    .active {
      background-color: #6c757d;
      color: #fff;
    }
    .select-box {
      border: 0px solid black !important;
      .maintitle {
        height: 10vh;
        h2 {
          position: relative;
          left: 0;
          text-align: center;
        }
      }
    }
  }
</style>
